import swiper from "swiper";
import isMobile from "./is-mobile.js";

var serviseNav = new swiper(".js-c-slider", {
  direction: "horizontal",
  loop: true,
  speed: 800,
  autoplay: true,
  spaceBetween: 30,
  centeredSlides: true,
  observer: true,
  allowTouchMove: true,
  preloadImages: false,
  autoHeight: true,
  slidesPerView: 4.5,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    960: {
      slidesPerView: 2,
    },
    414: {
      autoHeight: false,
      slidesPerView: 1,
    },
  },
});

var serviseNav02 = new swiper(".js-c-slider02", {
  direction: "horizontal",
  loop: true,
  speed: 1000,
  autoplay: true,
  spaceBetween: 30,
  centeredSlides: true,
  observer: true,
  allowTouchMove: true,
  preloadImages: false,
  autoHeight: true,
  slidesPerView: 2,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 5.5,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1024: {
      autoHeight: false,
      slidesPerView: 1.5,
    },
    414: {
      autoHeight: false,
      slidesPerView: 1,
    },
  },
});
var items = $(".c-campaign-items").length;

if (items >= 6 || isMobile(768)) {
  var serviseNav03 = new swiper(".js-c-slider03", {
    direction: "horizontal",
    loop: true,
    speed: 800,
    autoplay: true,
    spaceBetween: 15,
    centeredSlides: true,
    observer: true,
    allowTouchMove: true,
    preloadImages: true,
    // autoHeight: true,
    slidesPerView: "auto",
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1260: {
        slidesPerView: 3.5,
        spaceBetween: 15,
      },
    },
    breakpoints: {
      768: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },
    },
  });
}

if (items >= 6 || isMobile(768)) {
  var serviseNav04 = new swiper(".js-c-slider04", {
    direction: "horizontal",
    loop: true,
    speed: 800,
    autoplay: true,
    spaceBetween: 15,
    centeredSlides: true,
    observer: true,
    allowTouchMove: true,
    preloadImages: true,
    // autoHeight: true,
    slidesPerView: "auto",
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1260: {
        slidesPerView: 3.5,
        spaceBetween: 15,
      },
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
  });
}

if (items >= 6 || isMobile(768)) {
  var serviseNav05 = new swiper(".js-c-slider05", {
    direction: "horizontal",
    loop: true,
    speed: 800,
    autoplay: true,
    spaceBetween: 15,
    centeredSlides: true,
    observer: true,
    allowTouchMove: true,
    preloadImages: true,
    // autoHeight: true,
    slidesPerView: "auto",
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 2,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    },
    breakpoints: {
      765: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },
    },
  });
}

// if ($(".ua-ie").length) {
//   $(".top-spot-description").matchHeight();
//   $(".top-spot-list-body-image").matchHeight();
// }
